import Intercom from '@intercom/messenger-js-sdk'

export const initIntercom = () => {
  Intercom({
    app_id: 'am45pre8'
  })
}

export default () => {}